import type { ReactNode } from "react"
import React, { createContext, useContext, useMemo } from "react"

import { ProviderErrors } from "~config/constants"
import type { PublicOutfitterFieldsFragment } from "~graphql/generated/graphql"

interface CurrentOutfitterContextType {
    currentOutfitter: PublicOutfitterFieldsFragment
}

// this is actually used in tests, but I cannot get eslint to be happy with it
// eslint-disable-next-line import/no-unused-modules
export const CurrentOutfitterContext = createContext<
    CurrentOutfitterContextType | undefined
>(undefined)

interface CurrentOutfitterProviderProps {
    readonly outfitter: PublicOutfitterFieldsFragment
    readonly children: ReactNode
}

export function CurrentOutfitterProvider({
    outfitter,
    children,
}: CurrentOutfitterProviderProps) {
    const value = useMemo(() => ({ currentOutfitter: outfitter }), [outfitter])

    return (
        <CurrentOutfitterContext.Provider value={value}>
            {children}
        </CurrentOutfitterContext.Provider>
    )
}

export function useCurrentOutfitter() {
    const context = useContext(CurrentOutfitterContext)

    if (context === undefined) {
        throw new Error(ProviderErrors.CurrentOutfitter)
    }

    return context
}
